import React from "react";
import { useNavigate } from "react-router-dom";


const AirportTaxiInfo = () => {
  const navigate = useNavigate();
  return (
    <div className="container mx-auto py-12 px-6 ">
           <div className="mt-8 text-center max-w-6xl">
      <h2 className="text-4xl font-bold mb-6 text-primary">
      Stress-Free Transfers to All Major UK Airports
          </h2>
                  <p className="text-md text-white max-w-5xl mx-auto">
                  Travelling to or from the airport can be stressful, but with Watford Taxi, your journey will always be smooth and reliable. Whether you're jetting off for a holiday or returning from a business trip, our airport taxi services are designed to ensure you travel in comfort, arrive on time, and feel completely at ease. We proudly serve all major UK airports, including Heathrow, Gatwick, Luton, Stansted, and London City Airport.        </p>
      </div>

<div className="mt-24 grid md:grid-cols-2 lg:grid-cols-2 gap-8 text-left">
  <div className="flex flex-col gap-9">
    <div className="flex items-center">
    <img
                src="/247.png"
                alt="Experience"
                className="w-12 mx-auto mr-3"
     />      <div>
        <h3 className="font-semibold text-xl  ">24/7 Availability</h3>
        <p className="text-gray-300 text-sm">Your travel plans don’t follow a strict schedule, and neither do we. At Watford Taxi, we offer round-the-clock availability, ensuring that no matter what time your flight departs or lands, there’s always a car ready to pick you up or drop you off.
        </p>
      </div>
    </div>
    <div className="flex items-center">
    <img
                src="/flight.png"
                alt="Experience"
                className="w-9 mx-auto mr-3"
     /> 
      <div>
        <h3 className="font-semibold text-xl">Flight Monitoring</h3>
        <p className="text-gray-300 text-sm">Worried about flight delays or changes to your schedule? Don’t be. We track your flight in real-time, adjusting your pick-up time if necessary to ensure you’re never left stranded or late. This means a seamless, stress-free transfer, with your driver waiting for you at the perfect time.
        </p>
      </div>
    </div>
    <div className="flex items-center">
    <img
                src="/meetgreet.png"
                alt="Experience"
                className="w-12 mx-auto mr-3"
     /> 
      <div>
        <h3 className="font-semibold text-xl">Meet & Greet Service</h3>
        <p className="text-gray-300 text-sm">Experience first-class treatment with our meet and greet service. Your driver will be waiting for you at the arrivals hall, ready to assist you with your luggage and escort you to your waiting taxi. No need to search for your car – we make your transition from airport to destination as smooth as possible.
        </p>
      </div>
    </div>
    
    <div className="flex items-center">
    <img
                src="/driverPro.png"
                alt="Experience"
                className="w-9 mx-auto mr-3"
     /> 
      <div>
        <h3 className="font-semibold text-xl">Professional Drivers </h3>
        <p className="text-gray-300 text-sm">Our drivers are experienced, fully licensed, and committed to providing an exceptional service. They will ensure you have a relaxing and safe journey, whether it's a short hop to Heathrow or a longer drive to Gatwick or Stansted.
        </p>
      </div>
    </div>
  </div>
  {/* Right Section: Image */}
  <div className="mt-5">
          <img
            src="/business1.png"
            alt="Watford Taxi Fleet"
            className="rounded-lg shadow-lg border-4 border-primary w-full transition-transform duration-300 hover:scale-105"
          />
        </div>
</div>

{/* compo section */}
<div className="bg-primary py-16 w-full text-center mt-5">
  <div className="text-center w-full">
    <h2 className="text-4xl font-bold text-gray-500">
      Comfortable and Versatile Fleet
    </h2>

    {/* Description */}
    <p className="mt-4 text-sm text-black max-w-3xl mx-auto">
    We understand that each traveller’s needs are different, so we offer a range of vehicles to suit every requirement. From stylish saloon cars for solo travellers to larger MPVs for families and groups, our fleet is designed to deliver comfort, safety, and a touch of luxury. Executive cars are also available for those who prefer to travel in style.
    </p>

    {/* Vehicle Cards */}
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10 px-6">
      {/* Saloon Cars Card */}
      <div className="bg-dark p-6 rounded-lg shadow-lg hover:scale-105 transition-transform">
        <div className="text-yellow-500 text-5xl mb-4">
          <i className="fas fa-car"></i>
        </div>
        <h3 className="text-xl font-bold mt-4 text-primary">Saloon Cars</h3>
        <p className="text-gray-300 mt-2">
        Perfect for individuals or couples with light luggage.
        </p>
      </div>

      {/* MPVs Card */}
      <div className="bg-dark p-6 rounded-lg shadow-lg hover:scale-105 transition-transform">
        <div className="text-yellow-500 text-5xl mb-4">
          <i className="fas fa-bus"></i>
        </div>
        <h3 className="text-xl font-bold mt-4 text-primary">MPVs</h3>
        <p className="text-gray-300 mt-2">
        Ideal for families or small groups, with plenty of space for both passengers and luggage.
        </p>
      </div>

      {/* Executive Cars Card */}
      <div className="bg-dark p-6 rounded-lg shadow-lg hover:scale-105 transition-transform">
        <div className="text-yellow-500 text-5xl mb-4">
          <i className="fas fa-briefcase"></i>
        </div>
        <h3 className="text-xl font-bold mt-4 text-primary">Executive Cars</h3>
        <p className="text-gray-300 mt-2">
        For those who want to travel in luxury and style.
        </p>
      </div>
    </div>
  </div>
</div>


<div className=" py-16 w-full text-white">
  <div className="max-w-7xl mx-auto px-6">
    {/* Fixed, Competitive Pricing Section */}
    <section className="mb-20 text-center">
      <h2 className="text-4xl font-extrabold mb-6">
        Fixed, Competitive Pricing – No Hidden Costs
      </h2>
      <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto">
      We believe in transparent pricing, which means when you book an airport transfer with us, you’ll know exactly what to expect. Our rates are competitive, with no hidden fees, surcharges, or extra costs for late-night or early morning travel. You’ll enjoy great value, combined with a high-quality service, every time.
      </p>
      <div className="mt-12">
        <button className="bg-primary text-gray-800 font-semibold py-2 px-6 rounded-lg hover:bg-yellow-400 transition duration-300">
          Learn More
        </button>
      </div>
    </section>

    {/* Areas We Serve Section */}
    <section className="bg-dark py-16 rounded-lg shadow-xl mb-20">
      <div className="text-center">
        <h2 className="text-4xl font-extrabold text-yellow-400 mb-6">
          Areas We Serve
        </h2>
        <p className="text-lg text-gray-300 max-w-3xl mx-auto mb-12">
        We provide airport transfers across Watford and the surrounding areas, including nearby towns like Bushey, Rickmansworth, Croxley Green, and Abbots Langley. No matter where you're based, we’ll get you to the airport with plenty of time to spare or pick you up for a relaxing journey home.
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
          <div className="border border-[5px] border-primary p-6 rounded-lg text-center text-white shadow-lg">
            <i className="fas fa-map-marker-alt text-4xl mb-4"></i>
            <h3 className="text-2xl font-semibold mb-4">Watford</h3>
            <p>We cover all major locations in Watford for your convenience.</p>
          </div>
          <div className="border border-[5px] border-primary p-6 rounded-lg text-center text-white shadow-lg">
            <i className="fas fa-map-marker-alt text-4xl mb-4"></i>
            <h3 className="text-2xl font-semibold mb-4">Bushey</h3>
            <p>Serving Bushey and its surrounding areas with reliable transfers.</p>
          </div>
          <div className="border border-[5px] border-primary p-6 rounded-lg text-center text-white shadow-lg">
            <i className="fas fa-map-marker-alt text-4xl mb-4"></i>
            <h3 className="text-2xl font-semibold mb-4">Rickmansworth</h3>
            <p>Offering top-notch airport services to and from Rickmansworth.</p>
          </div>
        </div>
      </div>
    </section>

    {/* How to Book Your Airport Taxi Section */}
    <section className=" py-3 text-center ">
      <h2 className="text-4xl font-extrabold text-white mb-6">
        How to Book Your Airport Taxi
      </h2>
      <p className="text-lg text-gray-100 max-w-3xl mx-auto mb-12">
      Booking with Watford Taxi couldn’t be easier. Our online booking system is quick, simple, and secure. Just enter your details, choose your vehicle, and relax knowing your airport transfer is sorted. You’ll receive instant confirmation, so you can travel with complete peace of mind.
      </p>
      <div>
  <button
    onClick={() => {
      navigate("/"); 
      setTimeout(() => { 
        const bookNowSection = document.getElementById("book-now");
        if (bookNowSection) {
          bookNowSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); 
    }}
    className="bg-yellow-500 text-gray-800 font-semibold py-3 px-8 rounded-lg hover:bg-yellow-400 transition duration-300"
  >
    Book Now
  </button>
</div>
    </section>
  </div>
</div>


    </div>
  );
};

export default AirportTaxiInfo;
